var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"gradient-background"},[_c('v-container',{staticClass:"py-0",staticStyle:{"max-width":"800px"}},[(_vm.$store.state.processes.onboarding.currentStep!=-1)?_c('router-view',{on:{"next":_vm.getCurrentStep}}):_vm._e()],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }